import React, { Component, Fragment } from 'react';

import Logo from 'assets/images/logo.svg';

import './styles.scss';

export default Page =>
  class extends Component {
    render() {
      return (
        <Fragment>
          <div className="account-pages">
            <div className="clearfix" />

            <div className="wrapper-page">
              <div className="text-center">
                <span className="logo">
                  <img src={Logo} alt="" />
                </span>
              </div>

              <Page {...this.props} />
            </div>
          </div>
        </Fragment>
      );
    }
  };



// WEBPACK FOOTER //
// ./src/layouts/Auth/index.js